






















































import ModalTabMixin from '@/mixins/modal-tab.mixin';
import TableMixin from '@/mixins/table.mixin';
import { Component, Mixins, PropSync } from 'vue-property-decorator';
import Modal from './bank-accounts.modal.vue';

@Component({
  components: {
    Modal,
  },
})
export default class TabBankAccounts extends Mixins(ModalTabMixin, TableMixin) {
  @PropSync('id', { type: String }) idSync!: string;
  modal = { id: '', open: false };

  columns = [
    {
      label: 'GENERAL.STATUS',
      name: 'isActive',
      sortable: true,
      align: 'center',
    },
    {
      label: 'GENERAL.BANK',
      name: 'bank',
      sortable: true,
      field: (row: { bank?: { bankName: string } }) => row.bank?.bankName,
    },
    { label: 'GENERAL.ACCOUNT_NAME', name: 'name', sortable: true },
    { label: 'GENERAL.BRANCH_NAME', name: 'branchName', sortable: true },
    { label: 'GENERAL.BANK_CODE', name: 'bankCode', sortable: true },
    {
      label: 'GENERAL.ACCOUNTING_CODE',
      name: 'accountingCode',
      sortable: true,
    },
    {
      label: 'GENERAL.COMPANY',
      name: 'company',
      field: (row: { company?: { name: string } }) => row.company?.name,
      sortable: true,
    },
    { label: 'GENERAL.ACTIONS', name: 'actions', align: 'center' },
  ];
}
